<template>
    <b-card class="bg-secondary border-0">
        <b-card-text>
            <div class="d-flex justify-content-between">
            <div>
                
                <h5><i class="fa fa-truck text-primary"></i> จำนวนที่วิ่งรถ</h5>
            </div>
            <div>
                <h4>{{ totalDeliveries }} 
                    <span class="text-muted">รอบ</span>
                </h4>
            </div>
            </div>
        </b-card-text>
        <hr class="my-3" />
        <b-card-text>
            <div class="d-flex justify-content-between">
            <div>
                <h5><i class="fa fa-wallet text-primary"></i> รายได้ประจำวัน</h5>
            </div>
            <div>
                <h4> {{ earnPerDay }}
                    <span class="text-muted">บาท</span>
                </h4>
            </div>
            </div>
        </b-card-text>
    </b-card>
</template>

<script>
import jobServices from "@/api/job.service.js";

export default {
    data(){
        return{
            totalDeliveries: 0,
            earnPerDay: 0
        }
    },
    mounted(){
        this.get()
    },
    methods:{
        async get(){
            const { data } = await jobServices.getStatusDriver()
            if (data.statusCode === 200) {
                this.totalDeliveries = data.data.total_deliveries
                this.earnPerDay = data.data.earn_per_day
            }
        }
    }
}
</script>
